module.exports = __webpack_public_path__ + "img/DSCN1912.10d8ae57.jpg";